import * as React from "react";
import { SVGProps } from "react";

interface RewardIconProps extends SVGProps<SVGSVGElement> {
    width?: string;
    height?: string;
}
export const RewardIcon = (props: RewardIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width ?? 28.573}
        height={props.height ?? 20.091}
        viewBox="0 0 28.573 20.091"
        {...props}
    >
        <g id="Layer_x0020_1" transform="translate(-0.1 -1.025)">
            <g id="_309900632" transform="translate(0.35 1.275)">
                <path
                    id="_309901976"
                    d="M3.072,8.152h0Zm7.178,0h0Zm-8.89.329h0Zm10.24.244h0ZM4,9.25v0Zm-.448.058h0s0,0,0,0Zm.233.451a.4.4,0,0,1-.367-.235L2.844,8.3l-1.138.726a.405.405,0,0,1-.616-.416A14.257,14.257,0,0,1,2.163,5.245a.322.322,0,0,1,.583.271,13.474,13.474,0,0,0-.91,2.662l.89-.568a.405.405,0,0,1,.585.169l.391.837a10.175,10.175,0,0,1,2.75-5.1.321.321,0,0,1,.419,0,10.173,10.173,0,0,1,2.749,5.1l.39-.835a.405.405,0,0,1,.586-.17l.889.567a13.587,13.587,0,0,0-.9-2.647.321.321,0,1,1,.583-.27,14.3,14.3,0,0,1,1.066,3.346.405.405,0,0,1-.614.418L10.479,8.3,9.906,9.524a.4.4,0,0,1-.765-.094,10.593,10.593,0,0,0-2.48-5.223A10.6,10.6,0,0,0,4.18,9.43a.4.4,0,0,1-.348.325.409.409,0,0,1-.049,0Z"
                    transform="translate(2.276 6.456)"
                    fill="#141414"
                    stroke="#141414"
                    strokeWidth={0.5}
                    fillRule="evenodd"
                />
                <path
                    id="_309902024"
                    d="M3.271,3.551a.526.526,0,0,0-.4.234,1.158,1.158,0,0,0,0,1.3.529.529,0,0,0,.4.234.526.526,0,0,0,.4-.228,1.084,1.084,0,0,0,.2-.654,1.087,1.087,0,0,0-.2-.654.52.52,0,0,0-.4-.228Zm0,2.407a1.153,1.153,0,0,1-.916-.493,1.8,1.8,0,0,1,0-2.064,1.15,1.15,0,0,1,.916-.493,1.147,1.147,0,0,1,.909.483,1.73,1.73,0,0,1,.332,1.042,1.731,1.731,0,0,1-.333,1.044,1.139,1.139,0,0,1-.908.481Z"
                    transform="translate(5.667 4.574)"
                    fill="#141414"
                    stroke="#141414"
                    strokeWidth={0.5}
                    fillRule="evenodd"
                />
                <path
                    id="_309902408"
                    d="M2.19,8.881a.833.833,0,0,1-.339-.072.843.843,0,0,1-.47-.541,9.775,9.775,0,0,1-.306-2.546,9.82,9.82,0,0,1,.3-2.534.839.839,0,0,1,1.189-.524.321.321,0,0,1-.292.573A.191.191,0,0,0,2.11,3.23.2.2,0,0,0,2,3.36a9.171,9.171,0,0,0-.279,2.361A9.122,9.122,0,0,0,2,8.092a.2.2,0,0,0,.111.129.191.191,0,0,0,.165,0,.321.321,0,1,1,.285.576.837.837,0,0,1-.371.087Z"
                    transform="translate(2.25 3.366)"
                    fill="#141414"
                    stroke="#141414"
                    strokeWidth={0.5}
                    fillRule="evenodd"
                />
                <path
                    id="_309902240"
                    d="M1.62,6.022a.321.321,0,0,1-.157-.6L5.074,3.4a.321.321,0,1,1,.314.561L1.777,5.98a.319.319,0,0,1-.157.041Z"
                    transform="translate(3.049 6.171)"
                    fill="#141414"
                    stroke="#141414"
                    strokeWidth={0.5}
                    fillRule="evenodd"
                />
                <path
                    id="_309901928"
                    d="M5.229,5.079a.32.32,0,0,1-.146-.036L1.474,3.191a.321.321,0,0,1,.293-.572L5.376,4.471a.322.322,0,0,1-.147.608Z"
                    transform="translate(3.051 3.41)"
                    fill="#141414"
                    stroke="#141414"
                    strokeWidth={0.5}
                    fillRule="evenodd"
                />
                <path
                    id="_309901640"
                    d="M6.517,8.881a.837.837,0,0,1-.371-.087l-.014-.008-3.6-2.015a.321.321,0,1,1,.314-.561l3.586,2.01a.19.19,0,0,0,.158,0,.2.2,0,0,0,.112-.13,9.1,9.1,0,0,0,.281-2.371A9.147,9.147,0,0,0,6.71,3.359.2.2,0,0,0,6.6,3.23a.19.19,0,0,0-.166.005.322.322,0,0,1-.293-.572.839.839,0,0,1,1.19.523,9.818,9.818,0,0,1,.3,2.535,9.747,9.747,0,0,1-.305,2.546.842.842,0,0,1-.47.543.833.833,0,0,1-.339.072Z"
                    transform="translate(6.895 3.366)"
                    fill="#141414"
                    stroke="#141414"
                    strokeWidth={0.5}
                    fillRule="evenodd"
                />
                <path
                    id="_309901352"
                    d="M2.694,5.07a.321.321,0,0,1-.147-.607l3.59-1.844a.322.322,0,0,1,.294.572L2.841,5.034a.321.321,0,0,1-.147.036Z"
                    transform="translate(6.896 3.41)"
                    fill="#141414"
                    stroke="#141414"
                    strokeWidth={0.5}
                    fillRule="evenodd"
                />
                <path
                    id="_309901304"
                    d="M2.063,1.918A1.072,1.072,0,0,0,.992,2.989V19.153a1.072,1.072,0,0,0,1.071,1.07H26.709a1.072,1.072,0,0,0,1.071-1.07V2.989a1.072,1.072,0,0,0-1.071-1.07H2.063ZM26.709,20.866H2.063A1.715,1.715,0,0,1,.35,19.153V2.989A1.715,1.715,0,0,1,2.063,1.275H26.709a1.716,1.716,0,0,1,1.714,1.713V19.153a1.715,1.715,0,0,1-1.714,1.713Z"
                    transform="translate(-0.35 -1.275)"
                    fill="#141414"
                    stroke="#141414"
                    strokeWidth={0.5}
                    fillRule="evenodd"
                />
                <path
                    id="_309901112"
                    d="M4.123,4.2H.671a.321.321,0,1,1,0-.643H4.123a.321.321,0,0,1,0,.643Z"
                    transform="translate(-0.35 6.89)"
                    fill="#141414"
                    stroke="#141414"
                    strokeWidth={0.5}
                    fillRule="evenodd"
                />
                <path
                    id="_309901520"
                    d="M4,3.774H.671a.321.321,0,1,1,0-.643H4a.321.321,0,0,1,0,.643H4Z"
                    transform="translate(-0.35 5.371)"
                    fill="#141414"
                    stroke="#141414"
                    strokeWidth={0.5}
                    fillRule="evenodd"
                />
                <path
                    id="_309900968"
                    d="M17.347,4.2H3.674a.321.321,0,1,1,0-.643H17.347a.321.321,0,0,1,0,.643Z"
                    transform="translate(10.405 6.89)"
                    fill="#141414"
                    stroke="#141414"
                    strokeWidth={0.5}
                    fillRule="evenodd"
                />
                <path
                    id="_309901040"
                    d="M17.251,3.774H3.7a.321.321,0,1,1,0-.643h13.55a.321.321,0,0,1,0,.643Z"
                    transform="translate(10.501 5.371)"
                    fill="#141414"
                    stroke="#141414"
                    strokeWidth={0.5}
                    fillRule="evenodd"
                />
                <path
                    id="_309900944"
                    d="M2.34,12.239a.322.322,0,0,1-.321-.321V4.005a.321.321,0,1,1,.643,0v7.912a.321.321,0,0,1-.321.321Z"
                    transform="translate(5.626 7.352)"
                    fill="#141414"
                    stroke="#141414"
                    strokeWidth={0.5}
                    fillRule="evenodd"
                />
                <path
                    id="_309901472"
                    d="M2.764,12.238a.321.321,0,0,1-.321-.321V4.006a.321.321,0,1,1,.642,0v7.91a.321.321,0,0,1-.321.321Z"
                    transform="translate(7.146 7.353)"
                    fill="#141414"
                    stroke="#141414"
                    strokeWidth={0.5}
                    fillRule="evenodd"
                />
                <path
                    id="_309901016"
                    d="M2.764,9.591a.321.321,0,0,1-.321-.321V1.6a.321.321,0,1,1,.642,0V9.27a.321.321,0,0,1-.321.321Z"
                    transform="translate(7.146 -1.275)"
                    fill="#141414"
                    stroke="#141414"
                    strokeWidth={0.5}
                    fillRule="evenodd"
                />
                <path
                    id="_309900296"
                    d="M2.34,9.6a.322.322,0,0,1-.321-.321V1.6a.321.321,0,0,1,.643,0V9.282A.321.321,0,0,1,2.34,9.6Z"
                    transform="translate(5.626 -1.275)"
                    fill="#141414"
                    stroke="#141414"
                    strokeWidth={0.5}
                    fillRule="evenodd"
                />
                <path
                    id="_309900224"
                    d="M6.137,3.176a.322.322,0,0,1-.321-.321V2a.321.321,0,1,1,.643,0v.853A.322.322,0,0,1,6.137,3.176Z"
                    transform="translate(19.228 0.177)"
                    fill="#141414"
                    stroke="#141414"
                    strokeWidth={0.5}
                    fillRule="evenodd"
                />
                <path
                    id="_309900800"
                    d="M5.763,3.176a.322.322,0,0,1-.322-.321V2a.321.321,0,1,1,.643,0v.853A.322.322,0,0,1,5.763,3.176Z"
                    transform="translate(17.886 0.177)"
                    fill="#141414"
                    stroke="#141414"
                    strokeWidth={0.5}
                    fillRule="evenodd"
                />
                <path
                    id="_309900752"
                    d="M5.388,3.176a.321.321,0,0,1-.321-.321V2a.321.321,0,1,1,.643,0v.853A.321.321,0,0,1,5.388,3.176Z"
                    transform="translate(16.544 0.177)"
                    fill="#141414"
                    stroke="#141414"
                    strokeWidth={0.5}
                    fillRule="evenodd"
                />
                <path
                    id="_309900656"
                    d="M5.013,3.176a.322.322,0,0,1-.321-.321V2a.321.321,0,1,1,.643,0v.853A.321.321,0,0,1,5.013,3.176Z"
                    transform="translate(15.202 0.177)"
                    fill="#141414"
                    stroke="#141414"
                    strokeWidth={0.5}
                    fillRule="evenodd"
                />
            </g>
        </g>
    </svg>
);
